import React, { Component } from 'react'
import './learning-outcome.scss'
import { ImageConstants, Constants } from '../../../constants/constants'
import { getImageSource } from '../../../utility/image-source'
import SchoolUserApi from '../../../apis/student'
import Dropdown from '../../common/dropdown-v2/dropdown'

class LearningOutcome extends Component {
  state = {
    noviceStudents: [],
    proficientStudents: [],
    advancedStudents: [],
    types: []
  }

  componentDidMount () {
    const { selectedClass } = this.props
    const payload = {}
    if (selectedClass && selectedClass !== 'All') {
      payload.class = selectedClass
      this.setState({
        selectedClass: payload.class
      })
    }
  }

  getLearningOutcomes (payload = {}) {
    // Write API here
  }

  render () {
    const { selectedClass } = this.props
    return (
      <>
        <div className='learning-outcome'>
          {selectedClass === 'Class 6' && (
            <>
              <div className='lo-container'>
                <div className='lo-table-header'>
                  <img
                    className='scholar-img-black'
                    src={getImageSource(ImageConstants.STRENGTH_ICN)}
                  />
                  Strength
                </div>
                <div id='table-scoll' className='table-responsive'>
                  <table
                    className='table cw-table mb-0 align-items-center lo-table-strength'
                    cellspacing='0'
                  >
                    <thead>
                      <tr>
                        <th className='th-left-radius test-text'>CONCEPTS</th>
                      </tr>
                    </thead>
                    <tbody className='bg-white'>
                      <tr>
                        <td>Identify basic 2D shapes</td>
                      </tr>
                      <tr>
                        <td>Understand the concept of fraction</td>
                      </tr>
                      <tr>
                        <td>
                          Read and write numbers/ number names using place value
                          tables
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='lo-table-header'>
                  <img
                    className='scholar-img-black'
                    src={getImageSource(ImageConstants.WEAKNESS_ICN)}
                  />
                  Weakness
                </div>
                <div id='table-scoll' className='table-responsive'>
                  <table
                    className='table cw-table mb-0 align-items-center lo-table-weakness'
                    cellspacing='0'
                  >
                    <thead>
                      <tr>
                        <th className='th-left-radius test-text'>CONCEPTS</th>
                      </tr>
                    </thead>
                    <tbody className='bg-white'>
                      <tr>
                        <td>
                          Find strategy to solve problems on metric units.
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Express the quantities given in metric units using
                          decimals
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Find strategy to solve problems on time and money
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}

          {selectedClass === 'Class 7' && (
            <>
              <div className='lo-container'>
                <div className='lo-header'>
                  STRUGGLERS{' '}
                  <span>
                    <img
                      className='scholar-img-black'
                      src={getImageSource(ImageConstants.SCHOLAR_BLACK)}
                    />
                  </span>
                </div>
                <div className='lo-table-header'>
                  <img
                    className='scholar-img-black'
                    src={getImageSource(ImageConstants.STRENGTH_ICN)}
                  />
                  Strength
                </div>
                <div id='table-scoll' className='table-responsive'>
                  <table
                    className='table cw-table mb-0 align-items-center lo-table-strength'
                    cellspacing='0'
                  >
                    <thead>
                      <tr>
                        <th className='th-left-radius test-text'>CONCEPTS</th>
                      </tr>
                    </thead>
                    <tbody className='bg-white'>
                      <tr>
                        <td>Convert mixed fractions to improper fractions</td>
                      </tr>
                      <tr>
                        <td>Identify the triangles based on sides</td>
                      </tr>
                      <tr>
                        <td>
                          Use the formula to find the area of a rectangle.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='lo-table-header'>
                  <img
                    className='scholar-img-black'
                    src={getImageSource(ImageConstants.WEAKNESS_ICN)}
                  />
                  Weakness
                </div>
                <div id='table-scoll' className='table-responsive'>
                  <table
                    className='table cw-table mb-0 align-items-center lo-table-weakness'
                    cellspacing='0'
                  >
                    <thead>
                      <tr>
                        <th className='th-left-radius test-text'>CONCEPTS</th>
                      </tr>
                    </thead>
                    <tbody className='bg-white'>
                      <tr>
                        <td>Compare unlike fractions</td>
                      </tr>
                      <tr>
                        <td>Subtract two unlike fractions</td>
                      </tr>
                      <tr>
                        <td>Find the perimeter of closed figures</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className='lo-container'>
                <div className='lo-header'>
                  PROFICIENT{' '}
                  <span>
                    <img
                      className='scholar-img-black'
                      src={getImageSource(ImageConstants.SCHOLAR_BLACK)}
                    />
                  </span>
                </div>
                <div className='lo-table-header'>
                  <img
                    className='scholar-img-black'
                    src={getImageSource(ImageConstants.STRENGTH_ICN)}
                  />
                  Strength
                </div>
                <div id='table-scoll' className='table-responsive'>
                  <table
                    className='table cw-table mb-0 align-items-center lo-table-strength'
                    cellspacing='0'
                  >
                    <thead>
                      <tr>
                        <th className='th-left-radius test-text'>CONCEPTS</th>
                      </tr>
                    </thead>
                    <tbody className='bg-white'>
                      <tr>
                        <td>
                          Arrange integers in ascending and descending order
                        </td>
                      </tr>
                      <tr>
                        <td>Addition of integers</td>
                      </tr>
                      <tr>
                        <td>Determine prime factors by division method</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='lo-table-header'>
                  <img
                    className='scholar-img-black'
                    src={getImageSource(ImageConstants.WEAKNESS_ICN)}
                  />
                  Weakness
                </div>
                <div id='table-scoll' className='table-responsive'>
                  <table
                    className='table cw-table mb-0 align-items-center lo-table-weakness'
                    cellspacing='0'
                  >
                    <thead>
                      <tr>
                        <th className='th-left-radius test-text'>CONCEPTS</th>
                      </tr>
                    </thead>
                    <tbody className='bg-white'>
                      <tr>
                        <td>
                          Arrange unlike fractions in ascending/descending order
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Simplify integer expressions involving addition and
                          subtraction
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Simplify integer expressions involving addition and
                          subtraction
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className='lo-container'>
                <div className='lo-header'>
                  ADVANCE{' '}
                  <span>
                    <img
                      className='scholar-img-black'
                      src={getImageSource(ImageConstants.SCHOLAR_BLACK)}
                    />
                  </span>
                </div>
                <div className='lo-table-header'>
                  <img
                    className='scholar-img-black'
                    src={getImageSource(ImageConstants.STRENGTH_ICN)}
                  />
                  Strength
                </div>
                <div id='table-scoll' className='table-responsive'>
                  <table
                    className='table cw-table mb-0 align-items-center lo-table-strength'
                    cellspacing='0'
                  >
                    <thead>
                      <tr>
                        <th className='th-left-radius test-text'>CONCEPTS</th>
                      </tr>
                    </thead>
                    <tbody className='bg-white'>
                      <tr>
                        <td>Determine prime factors by division method</td>
                      </tr>
                      <tr>
                        <td>
                          Find a strategy to solve real-life problems based on
                          decimal addition and subtraction
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Find a strategy to solve real-life problems based on
                          decimal addition and subtraction
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='lo-table-header'>
                  <img
                    className='scholar-img-black'
                    src={getImageSource(ImageConstants.WEAKNESS_ICN)}
                  />
                  Weakness
                </div>
                <div id='table-scoll' className='table-responsive'>
                  <table
                    className='table cw-table mb-0 align-items-center lo-table-weakness'
                    cellspacing='0'
                  >
                    <thead>
                      <tr>
                        <th className='th-left-radius test-text'>CONCEPTS</th>
                      </tr>
                    </thead>
                    <tbody className='bg-white'>
                      <tr>
                        <td>
                          Find strategy to solve problems on metric units.
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Understand metric units of length, weight and capacity
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Express the given quantities money, length, weight as
                          decimals
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}

          {selectedClass === 'Class 8' && (
            <>
              <div className='lo-container'>
                <div className='lo-header'>
                  STRUGGLERS{' '}
                  <span>
                    <img
                      className='scholar-img-black'
                      src={getImageSource(ImageConstants.SCHOLAR_BLACK)}
                    />
                  </span>
                </div>
                <div className='lo-table-header'>
                  <img
                    className='scholar-img-black'
                    src={getImageSource(ImageConstants.STRENGTH_ICN)}
                  />
                  Strength
                </div>
                <div id='table-scoll' className='table-responsive'>
                  <table
                    className='table cw-table mb-0 align-items-center lo-table-strength'
                    cellspacing='0'
                  >
                    <thead>
                      <tr>
                        <th className='th-left-radius test-text'>CONCEPTS</th>
                      </tr>
                    </thead>
                    <tbody className='bg-white'>
                      <tr>
                        <td>Discover the product rule of exponents</td>
                      </tr>
                      <tr>
                        <td>
                          Identify number patterns represented through
                          geometrical shapes
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Multiply a rational number by another rational number
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='lo-table-header'>
                  <img
                    className='scholar-img-black'
                    src={getImageSource(ImageConstants.WEAKNESS_ICN)}
                  />
                  Weakness
                </div>
                <div id='table-scoll' className='table-responsive'>
                  <table
                    className='table cw-table mb-0 align-items-center lo-table-weakness'
                    cellspacing='0'
                  >
                    <thead>
                      <tr>
                        <th className='th-left-radius test-text'>CONCEPTS</th>
                      </tr>
                    </thead>
                    <tbody className='bg-white'>
                      <tr>
                        <td>Subtract two unlike fractions</td>
                      </tr>
                      <tr>
                        <td>Add two or more unlike fractions</td>
                      </tr>
                      <tr>
                        <td>
                          Add two rational numbers with diferent denominators
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className='lo-container'>
                <div className='lo-header'>
                  PROFICIENT{' '}
                  <span>
                    <img
                      className='scholar-img-black'
                      src={getImageSource(ImageConstants.SCHOLAR_BLACK)}
                    />
                  </span>
                </div>
                <div className='lo-table-header'>
                  <img
                    className='scholar-img-black'
                    src={getImageSource(ImageConstants.STRENGTH_ICN)}
                  />
                  Strength
                </div>
                <div id='table-scoll' className='table-responsive'>
                  <table
                    className='table cw-table mb-0 align-items-center lo-table-strength'
                    cellspacing='0'
                  >
                    <thead>
                      <tr>
                        <th className='th-left-radius test-text'>CONCEPTS</th>
                      </tr>
                    </thead>
                    <tbody className='bg-white'>
                      <tr>
                        <td>
                          Multiply a rational number by another rational number
                        </td>
                      </tr>
                      <tr>
                        <td>Determine prime factors by division method</td>
                      </tr>
                      <tr>
                        <td>
                          Add two rational numbers with diferent denominators
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='lo-table-header'>
                  <img
                    className='scholar-img-black'
                    src={getImageSource(ImageConstants.WEAKNESS_ICN)}
                  />
                  Weakness
                </div>
                <div id='table-scoll' className='table-responsive'>
                  <table
                    className='table cw-table mb-0 align-items-center lo-table-weakness'
                    cellspacing='0'
                  >
                    <thead>
                      <tr>
                        <th className='th-left-radius test-text'>CONCEPTS</th>
                      </tr>
                    </thead>
                    <tbody className='bg-white'>
                      <tr>
                        <td>Subtract two unlike fractions</td>
                      </tr>
                      <tr>
                        <td>Add two or more unlike fractions</td>
                      </tr>
                      <tr>
                        <td>Subtraction of two rational numbers</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className='lo-container'>
                <div className='lo-header'>
                  ADVANCE{' '}
                  <span>
                    <img
                      className='scholar-img-black'
                      src={getImageSource(ImageConstants.SCHOLAR_BLACK)}
                    />
                  </span>
                </div>
                <div className='lo-table-header'>
                  <img
                    className='scholar-img-black'
                    src={getImageSource(ImageConstants.STRENGTH_ICN)}
                  />
                  Strength
                </div>
                <div id='table-scoll' className='table-responsive'>
                  <table
                    className='table cw-table mb-0 align-items-center lo-table-strength'
                    cellspacing='0'
                  >
                    <thead>
                      <tr>
                        <th className='th-left-radius test-text'>CONCEPTS</th>
                      </tr>
                    </thead>
                    <tbody className='bg-white'>
                      <tr>
                        <td>
                          Discover how to express the larger numbers in standard
                          form
                        </td>
                      </tr>
                      <tr>
                        <td>Determine prime factors by division method</td>
                      </tr>
                      <tr>
                        <td>
                          Solve word problems based on finding the percentage of
                          a quantity
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='lo-table-header'>
                  <img
                    className='scholar-img-black'
                    src={getImageSource(ImageConstants.WEAKNESS_ICN)}
                  />
                  Weakness
                </div>
                <div id='table-scoll' className='table-responsive'>
                  <table
                    className='table cw-table mb-0 align-items-center lo-table-weakness'
                    cellspacing='0'
                  >
                    <thead>
                      <tr>
                        <th className='th-left-radius test-text'>CONCEPTS</th>
                      </tr>
                    </thead>
                    <tbody className='bg-white'>
                      <tr>
                        <td>
                          Solve problems by equating exponents on LHS and RHS to
                          find the unknown exponents
                        </td>
                      </tr>
                      <tr>
                        <td>Solve word problems based on Simple interest</td>
                      </tr>
                      <tr>
                        <td>
                          Strategy to solve problems using the appropriate laws
                          of exponents
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}

          {selectedClass === 'Class 9' && (
            <>
              <div className='lo-container'>
                <div className='lo-header'>
                  STRUGGLERS{' '}
                  <span>
                    <img
                      className='scholar-img-black'
                      src={getImageSource(ImageConstants.SCHOLAR_BLACK)}
                    />
                  </span>
                </div>
                <div className='lo-table-header'>
                  <img
                    className='scholar-img-black'
                    src={getImageSource(ImageConstants.STRENGTH_ICN)}
                  />
                  Strength
                </div>
                <div id='table-scoll' className='table-responsive'>
                  <table
                    className='table cw-table mb-0 align-items-center lo-table-strength'
                    cellspacing='0'
                  >
                    <thead>
                      <tr>
                        <th className='th-left-radius test-text'>CONCEPTS</th>
                      </tr>
                    </thead>
                    <tbody className='bg-white'>
                      <tr>
                        <td>
                          Find the product of two binomials of the form (a+b) (a
                          -b)
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Find the product of two binomials of the form (x+a)
                          (x+b)
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Use the identity to find the product of binomials of
                          the form (a-b) (a-b)
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='lo-table-header'>
                  <img
                    className='scholar-img-black'
                    src={getImageSource(ImageConstants.WEAKNESS_ICN)}
                  />
                  Weakness
                </div>
                <div id='table-scoll' className='table-responsive'>
                  <table
                    className='table cw-table mb-0 align-items-center lo-table-weakness'
                    cellspacing='0'
                  >
                    <thead>
                      <tr>
                        <th className='th-left-radius test-text'>CONCEPTS</th>
                      </tr>
                    </thead>
                    <tbody className='bg-white'>
                      <tr>
                        <td>Subtract two unlike fractions</td>
                      </tr>
                      <tr>
                        <td>Add two or more unlike fractions</td>
                      </tr>
                      <tr>
                        <td>
                          Add two rational numbers with diferent denominators
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className='lo-container'>
                <div className='lo-header'>
                  PROFICIENT{' '}
                  <span>
                    <img
                      className='scholar-img-black'
                      src={getImageSource(ImageConstants.SCHOLAR_BLACK)}
                    />
                  </span>
                </div>
                <div className='lo-table-header'>
                  <img
                    className='scholar-img-black'
                    src={getImageSource(ImageConstants.STRENGTH_ICN)}
                  />
                  Strength
                </div>
                <div id='table-scoll' className='table-responsive'>
                  <table
                    className='table cw-table mb-0 align-items-center lo-table-strength'
                    cellspacing='0'
                  >
                    <thead>
                      <tr>
                        <th className='th-left-radius test-text'>CONCEPTS</th>
                      </tr>
                    </thead>
                    <tbody className='bg-white'>
                      <tr>
                        <td>Solve a given simple linear equation</td>
                      </tr>
                      <tr>
                        <td>
                          Find the value of an expression by substitutting the
                          given value of the variable
                        </td>
                      </tr>
                      <tr>
                        <td>Perorm Operations with Rational Numbers</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='lo-table-header'>
                  <img
                    className='scholar-img-black'
                    src={getImageSource(ImageConstants.WEAKNESS_ICN)}
                  />
                  Weakness
                </div>
                <div id='table-scoll' className='table-responsive'>
                  <table
                    className='table cw-table mb-0 align-items-center lo-table-weakness'
                    cellspacing='0'
                  >
                    <thead>
                      <tr>
                        <th className='th-left-radius test-text'>CONCEPTS</th>
                      </tr>
                    </thead>
                    <tbody className='bg-white'>
                      <tr>
                        <td>Solve the given equation by transpose method</td>
                      </tr>
                      <tr>
                        <td>Subtraction of two rational numbers</td>
                      </tr>
                      <tr>
                        <td>
                          Add two rational numbers with diferent denominators
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className='lo-container'>
                <div className='lo-header'>
                  ADVANCE{' '}
                  <span>
                    <img
                      className='scholar-img-black'
                      src={getImageSource(ImageConstants.SCHOLAR_BLACK)}
                    />
                  </span>
                </div>
                <div className='lo-table-header'>
                  <img
                    className='scholar-img-black'
                    src={getImageSource(ImageConstants.STRENGTH_ICN)}
                  />
                  Strength
                </div>
                <div id='table-scoll' className='table-responsive'>
                  <table
                    className='table cw-table mb-0 align-items-center lo-table-strength'
                    cellspacing='0'
                  >
                    <thead>
                      <tr>
                        <th className='th-left-radius test-text'>CONCEPTS</th>
                      </tr>
                    </thead>
                    <tbody className='bg-white'>
                      <tr>
                        <td>
                          Find strategy to solve contextual problems on simple
                          linear equations
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Find a strategy to find the squares of numbers [by
                          applying the identity (a+b)^2 = a^2 + 2ab + b^2]
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Find a strategy to find the square of numbers [by
                          applying the identity (a-b)^2 = a^2 - 2ab + b^2]
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='lo-table-header'>
                  <img
                    className='scholar-img-black'
                    src={getImageSource(ImageConstants.WEAKNESS_ICN)}
                  />
                  Weakness
                </div>
                <div id='table-scoll' className='table-responsive'>
                  <table
                    className='table cw-table mb-0 align-items-center lo-table-weakness'
                    cellspacing='0'
                  >
                    <thead>
                      <tr>
                        <th className='th-left-radius test-text'>CONCEPTS</th>
                      </tr>
                    </thead>
                    <tbody className='bg-white'>
                      <tr>
                        <td>
                          Add two rational numbers with diferent denominators
                        </td>
                      </tr>
                      <tr>
                        <td>Subtraction of two rational numbers</td>
                      </tr>
                      <tr>
                        <td>
                          Find a strategy to simplify algebraic expressions
                          [using more than one identity]
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}
          {/* <div className='lo-footer'>
            <img
              className='scholar-img-black'
              src={getImageSource(ImageConstants.SCHOLAR_BLACK)}
            />
            <span className='skill-title'>: Number of Students</span>
          </div> */}
        </div>
      </>
    )
  }
}

export default LearningOutcome
